function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

/**
 * Return an array of every parent and optionally filter them by selector
 * @param {HTMLElement} element
 * @param {string | HTMLElement} [selector] Optional selector or element to match against
 * @returns {HTMLElement[]} The list of matched parent elements
 */
function getParentElements(element, selector) {
  let { parentElement: currentElement } = element;
  const matches = [];

  while (currentElement !== null) {
    if (!selector || currentElement === selector) {
      matches.push(currentElement);
    } else if (
      typeof selector === "string" &&
      currentElement.matches(selector)
    ) {
      matches.push(currentElement);
    }

    currentElement = currentElement.parentElement;
  }

  return matches;
}

function onSummaryClick(event) {
  /** @type {HTMLElement} */
  const clickedElement = event.currentTarget;
  const isOpen = !clickedElement.closest("details").hasAttribute("open");

  clickedElement.setAttribute("aria-expanded", isOpen);

  // close sibling navs
  if (isOpen) {
    /** @type {HTMLLIElement | null | undefined} */
    let previousElementSibling =
      clickedElement.closest("li")?.previousElementSibling;
    /** @type {HTMLLIElement | null | undefined} */
    let nextElementSibling = clickedElement.closest("li")?.nextElementSibling;

    // close prev siblings
    while (previousElementSibling) {
      previousElementSibling.querySelector("details")?.removeAttribute("open");
      previousElementSibling = previousElementSibling.previousElementSibling;
    }

    // close next siblings
    while (nextElementSibling) {
      nextElementSibling.querySelector("details")?.removeAttribute("open");
      nextElementSibling = nextElementSibling.nextElementSibling;
    }
  } else {
    const details =
      clickedElement.nextElementSibling?.querySelectorAll("details") || [];

    details.forEach((detail) => {
      detail.removeAttribute("open");
    });
  }

  /** @type {HTMLUListElement | undefined} */
  const parentMenu = clickedElement.closest(".header__submenu .list-menu");

  // if submenu
  if (parentMenu) {
    /** @type {HTMLDivElement | HTMLUListElement | null} */
    const content = clickedElement.nextElementSibling;

    // reset the parent height
    parentMenu.style.height = "";

    if (!isOpen) {
      return;
    }

    const { offsetHeight: parentHeight } = parentMenu;
    const { offsetHeight: childHeight } = content || {};

    // if child height is larger than the parent height
    if (parentHeight && childHeight && childHeight > parentHeight) {
      // set the parent height to the child height
      parentMenu.style.height = `${childHeight}px`;
    }
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", "false");

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", onSummaryClick);

  if (summary.closest("header-menu")) {
    let touchEvent = false;

    // fix touch events on mobile
    summary.addEventListener("touchstart", (event) => {
      touchEvent = true;
    });

    // on hover, add open attribute
    summary.addEventListener("mouseover", (event) => {
      // skip for touch events since open attribute is added natively
      if (touchEvent) {
        touchEvent = false;
        return;
      }

      /** @type {HTMLDetailsElement} */
      const details = event.currentTarget.closest('[id^="Details-"]');

      details.setAttribute("open", "");
      onSummaryClick(event);
    });

    /** @type {HTMLDetailsElement} */
    const details = summary.closest('[id^="Details-"]');

    if (details) {
      details.addEventListener("mouseleave", (event) => {
        /** @type {HTMLDetailsElement} */
        event.currentTarget.removeAttribute("open");
        onSummaryClick(event);
      });
    }
  }

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

/**
 * Mobile Menu Drawer Instance
 *
 * @typedef {{ element: HTMLDivElement; height: number; }} SubNavStack
 * @class MenuDrawer
 * @extends {HTMLElement}
 */
class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  /**
   * Sub-Navigation Stack Map
   *
   * @type {Map<HTMLElement, SubNavStack[]>}
   * @memberof MenuDrawer
   */
  subnavStacks = new Map();

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.slick-arrow)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  /**
   * Event Handler for Summary Element Clicks
   *
   * @param {MouseEvent} event
   * @memberof MenuDrawer
   */
  onSummaryClick(event) {
    /** @type {HTMLElement} */
    const summaryElement = event.currentTarget;

    /** @type {HTMLDetailsElement | null} */
    const detailsElement = summaryElement.parentNode;

    /** @type {HTMLDivElement | null} */
    const submenu = summaryElement.nextElementSibling;

    const missingElements = [];

    if (!submenu) {
      missingElements.push("submenu");
    }
    if (!detailsElement) {
      missingElements.push("details");
    }

    if (!submenu || !detailsElement) {
      throw new Error(
        `Invalid Menu Structure: check the ${missingElements.join(
          "and"
        )} element`
      );
    }

    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) {
        event.preventDefault();
        this.closeMenuDrawer(event, summaryElement);

        // reset heights for all subnavs
        Array.from(this.querySelectorAll(".menu-drawer__submenu")).forEach(
          (submenu) => {
            const isTopLevelSubmenu = !getParentElements(
              submenu,
              ".menu-drawer__submenu"
            ).length;

            if (isTopLevelSubmenu) {
              // reset stack
              this.subnavStacks.set(submenu, []);
              submenu.style.height = "";
            }
          }
        );
      } else {
        this.openMenuDrawer(summaryElement);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);

        const parents = getParentElements(
          detailsElement,
          ".menu-drawer__submenu"
        );
        const topMostSubmenu =
          parents[parents.length - 1] || summaryElement.nextElementSibling;
        const stack = this.subnavStacks.get(topMostSubmenu) || [];

        if (isOpen) {
          let remainingToRemove = parents.length || Infinity;
          let stackItem;

          while (stack.length && remainingToRemove) {
            stack.pop();
            stackItem = stack[stack.length - 1];
            remainingToRemove -= 1;
          }

          if (stackItem) {
            topMostSubmenu.style.height = `${stackItem.height}px`;
          } else {
            topMostSubmenu.style.height = "";
          }
        } else {
          const parentSubmenu = parents[0];

          // update drawer submenu height
          if (
            submenu.classList.contains("menu-drawer__submenu") &&
            parentSubmenu
          ) {
            /** @type {SubNavStack[]} */

            stack.push({ element: submenu, height: submenu.scrollHeight });
            topMostSubmenu.style.height = `${submenu.scrollHeight}px`;
          }
        }

        this.subnavStacks.set(topMostSubmenu, stack);

        if (!reducedMotion || reducedMotion.matches) {
          addTrapFocus();
        } else {
          summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
        }
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    // Add is-active class to hamburger icon
    const hamburger = summaryElement.querySelector('.hamburger');
    if (hamburger) {
      hamburger.classList.add('is-active');
    }
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    // Remove is-active class from hamburger icon
    const hamburger = this.mainDetailsToggle.querySelector('.hamburger');
    if (hamburger) {
      hamburger.classList.remove('is-active');
    }
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);

    const parents = getParentElements(
      event.currentTarget,
      ".menu-drawer__submenu"
    );
    const topMostSubmenu = parents.pop();

    const stack = this.subnavStacks.get(topMostSubmenu) || [];
    stack.pop();
    const stackItem = stack.length ? stack[stack.length - 1] : undefined;
    topMostSubmenu.style = stackItem ? `${stackItem.height}px` : "";
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    if (this.header) {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    }
    if (this.header) {
      this.header.classList.add("menu-open");
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    // Add is-active class to hamburger icon
    const hamburger = summaryElement.querySelector('.hamburger');
    if (hamburger) {
      hamburger.classList.add('is-active');
    }
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    if (this.header) {
      this.header.classList.remove("menu-open");
    }
    // Remove is-active class from hamburger icon
    const hamburger = this.mainDetailsToggle.querySelector('.hamburger');
    if (hamburger) {
      hamburger.classList.remove('is-active');
    }
  }
}

customElements.define("header-drawer", HeaderDrawer);

class cartDrawer extends MenuDrawer {
  constructor() {
    super();
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindCartEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("[data-menu-close]").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
    this.querySelectorAll("upcart-header-close-button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    document.body.classList.remove(`overflow-hidden`);
    document.body.classList.remove(`modal-open-cart`);
    document.querySelector(".cartDrawer__items").innerHTML = "";
    this.closeSubmenu(detailsElement);
  }

  fetchCart = () => {
    const cartUrl = "/cart.js";
    fetch(cartUrl)
      .then((res) => res.json())
      .then((cartContents) => {
        this.buildCart(cartContents);
      });
  };

  async buildCart(content) {
    this.itemToAppendTo = document.querySelector(".cartDrawer__items");
    let htmlToAppend = "";
    //helper fn
    const numToPrice = (num) => {
      return `$${num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
    };
    //cleanup
    content.item_count
      ? document.querySelector(".cart-count-bubble").classList.remove("empty")
      : document.querySelector(".cart-count-bubble").classList.add("empty");
    document.querySelector(
      ".cart-count-bubble"
    ).innerHTML = `<span aria-hidden="true">${
      content.item_count
    }</span><span class="visually-hidden">${content.item_count} item${
      content.item_count !== 1 ? "s" : ""
    }</span>`;

    document.querySelector("[data-subtotal]").innerHTML = numToPrice(
      content.items_subtotal_price / 100
    );
    document.querySelector(
      "[data-bag-qty]"
    ).innerHTML = `<span data-cart-qty="${content.item_count}">${
      content.item_count
    }</span> Item${content.item_count !== 1 ? "s" : ""}`;

    const quantifier = (qty, index) => {
      return `<quantity-input class="quantity">
      <button class="quantity__button no-js-hidden" name="minus" type="button">
        <span class="visually-hidden">
          Decrease quantity
        </span>
        -
      </button>
      <input
        class="quantity__input"
        type="number"
        name="quantity"
        min="0"
        value="${qty}"
        data-index="${index + 1}"
      >
      <button class="quantity__button no-js-hidden" name="plus" type="button">
        <span class="visually-hidden">
          Increase quantity
        </span>
        +
      </button>
    </quantity-input>`;
    };

    if (content.items.length <= 0) {
      this.itemToAppendTo.innerHTML = `<p class="no-cart-items">No items in cart</p>`;
    } else {
      content.items.forEach((item, i) => {
        let itemHtml = "";
        //base HTML
        itemHtml += `
        <div class="cartItem-wrapper" id="cartItem-${i}" style="order:${i + 1}">
          <div class="left-wrapper">
            <img src="${item.featured_image.url
              .replace(/(\.[^.]*)$/, "_medium$1")
              .replace("http:", "")}">
            ${quantifier(item.quantity, i)}
            <p><strong>Total:</strong> ${numToPrice(
              item.final_line_price / 100
            )}</p>
          </div>
          <div class="right-wrapper">
            <a class="body-large" href="${item.url}">${item.product_title}</a>
            <button class="slick-arrow" data-index="${
              i + 1
            }" data-remove-item="${
          item.id
        }"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
          </svg>
          </button>
            <ul>
        `;
        // extra API request for sale price
        fetch(`/products/${item.handle}.js`)
        .then((res) => {
          return res.json();
        })
        .then(async (product) => {
          for (const prod of product.variants) {
            if (prod.id === item.variant_id) {
              const response = await fetch(`/variants/${item.variant_id}.json`);
              const jsonData = await response.json();
              const compareAtPrice = parseFloat(jsonData.product_variant.compare_at_price);
              const price = parseFloat(jsonData.product_variant.price);

              if (item.original_price && item.original_price > item.final_price) {
                itemHtml += `<li><span class="original-price"><span class="visually-hidden visually-hidden--inline">
                Original Price:
                </span><s>${numToPrice(
                  item.original_price / 100
                )}</s></span><span class="green">${numToPrice(
                  item.final_price / 100
                )}</span></li>`;
              } else {
                console.log("heeeeere", compareAtPrice, price);
                if (compareAtPrice > price) {
                  itemHtml += `<li> <span class="green" style="text-decoration: line-through;">$${compareAtPrice}</span> <span class="green">${numToPrice(item.final_price / 100)}</span></li>`;
                } else {
                  itemHtml += `<li> <span class="green">${numToPrice(item.final_price / 100)}</span></li>`;
                }
              }
            }
          }
        })

          //loop through options
          .then(() => {
            item.options_with_values.forEach((option) => {
              if (option.name != "Title") {
                itemHtml += `<li><strong>${option.name}: </strong>${option.value}</li>`;
              }
            });
            //end item
            itemHtml += `
          ${
            item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan.name
              ? "<li><strong>Subscription: </strong>" +
                item.selling_plan_allocation.selling_plan.name.split(
                  "Delivery every"
                )[1] +
                "</li>"
              : ""
          }
          </ul><div class="cart-item__error" id="cartDrawer-item-error-${
            i + 1
          }" role="alert">
          <small class="cart-item__error-text"></small>
          <svg
            aria-hidden="true"
            focusable="false"
            role="presentation"
            class="icon icon-error"
            viewBox="0 0 13 13"
          >
            <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
            <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
            <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
            <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
          </svg>
        </div></div></div>`;
          })
          .then(() => {
            htmlToAppend += itemHtml;
            if (content.items.length === i + 1) {
              this.itemToAppendTo.style.opacity = 0;
              setTimeout(() => {
                this.itemToAppendTo.innerHTML = htmlToAppend;
                this.itemToAppendTo.style.opacity = 1;
              }, 300);
            }
          });
      });
    }
  }

  bindCartEvents() {
    //debouncing so that multiple clicks to adj inventory only register as one function call
    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    //handle close button
    this.addEventListener("click", (e) => {
      const target = e.target.closest("[data-remove-item]");
      if (target) {
        e.preventDefault();
        const index = target.getAttribute("data-index");
        this.adjustQty(index, 0);
      }
    });

    //handle open button
    this.addEventListener("change", (e) => {
      if (e.target.classList.contains("quantity__input")) {
        this.debouncedOnChange(e);
      }
    });
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    document.body.classList.remove(`overflow-hidden`);
    document.body.classList.remove(`modal-open-cart`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onChange(e) {
    this.adjustQty(e.target.dataset.index, e.target.value);
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      //this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    //removing to fix UpCart document.body.classList.add(`overflow-hidden`);
    trapFocus(this.mainDetailsToggle, summaryElement);
    this.fetchCart(true);
  }

  adjustQty(line, quantity) {
    const cartUrl = "/cart/change.js";
    const numDiffItems = document.querySelectorAll(".cartItem-wrapper").length;

    const body = JSON.stringify({
      line,
      quantity,
    });

    fetch(cartUrl, { ...fetchConfig(), ...{ body } })
      .then((res) => {
        return res.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        let hasErrors = false;
        //determined if error should be triggered
        if (
          numDiffItems === parsedState.items.length &&
          parsedState.items[Number(line) - 1].quantity !== Number(quantity)
        ) {
          hasErrors = true;
        }

        return [parsedState, hasErrors];
      })
      .then((result) => {
        if (result[1]) {
          //if error
          //add error
          const maxQty = result[0].items[Number(line) - 1].quantity;
          //add error message
          document
            .getElementById(`cartDrawer-item-error-${line}`)
            .querySelector(".cart-item__error-text").innerHTML =
            window.cartStrings.quantityError.replace("[quantity]", maxQty);
          //add max
          /* document.querySelector(`#cartItem-${[Number(line) - 1]} .quantity__input`).setAttribute('max', maxQty); */
          document.querySelector(
            `#cartItem-${[Number(line) - 1]} .quantity__input`
          ).value = maxQty;
        } else {
          document
            .querySelectorAll(".cart-item__error-text")
            .forEach((errWrapper) => {
              errWrapper.innerHTML = "";
            });
          this.buildCart(result[0], false);
        }
      });
  }
}
customElements.define("cart-drawer", cartDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target.nodeName === "MODAL-DIALOG") this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);
class ProductModal extends ModalDialog {
  constructor() {
    super();
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
  }
}

if (!customElements.get("product-modal"))
  customElements.define("product-modal", ProductModal);
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, modal-opener, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    if (this.querySelector("[data-totalslides]") != null) {
      this.dotsTotal = Math.ceil(
        Number(this.querySelector("[data-totalslides]").dataset.totalslides) /
          Number(this.querySelector("[data-step]").dataset.step)
      );
    }

    this.dots = this.querySelectorAll(".slick-dots li");
    this.activeDot = this.querySelector(".slick-dots .slick-active");

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
      //handle dots
      this.dots.forEach((child) => {
        child.classList.remove("slick-active");
      });
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.styleSelects();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    if (document.getElementById(`id__${this.currentVariant.id}`)) {
      document.getElementById(`id__${this.currentVariant.id}`).click();
    }
    //mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    //const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    //const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    //modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        if (document.querySelector(".pt-points")) {
          document.querySelector(".pt-points").innerHTML = source.querySelector(
            "[data-selling-price]"
          ).dataset.sellingPrice;
        }
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  styleSelects() {
    new Choices(this.querySelector(".js-choice"), { allowHTML: true });
    const newName = this.querySelector(
      ".choices__item.choices__item--selectable"
    ).innerHTML.split("$")[0];
    this.querySelector(".choices__item--selectable").innerHTML = newName;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class VariantCard extends VariantSelects {
  constructor() {
    super();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateVariantInput();
      this.renderProductInfo();
    }
    this.handlePrices();
  }

  handlePrices() {
    const newName = this.currentVariant.title;
    console.log("this.currentVariant", this.currentVariant);
    const newPrice = `$${
      this.querySelector(".is-selected").innerText.split("$")[1]
    }`;
    const numToPrice = (num) => {
      return `$${num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}`;
    };

    const compareAt = this.currentVariant.compare_at_price
      ? `${numToPrice(this.currentVariant.compare_at_price/100)}`
      : null;
    this.querySelector(".choices__item--selectable").innerHTML = newName;
    //if its on sale
    if (compareAt && compareAt !== newPrice) {
      this.closest(".product-instance")
        .querySelectorAll(".price-msrp")
        .forEach((priceItem) => (priceItem.innerHTML = compareAt));
    } else {
      this.closest(".product-instance")
        .querySelectorAll(".price-msrp")
        .forEach((priceItem) => (priceItem.innerHTML = ""));
    }
    this.closest(".product-instance")
      .querySelectorAll(".price-item--regular")
      .forEach((priceItem) => {
        priceItem.innerHTML = newPrice;
      });
    this.closest(".product-instance")
      .querySelectorAll(".price-item")
      .forEach((priceItem) => {
        priceItem.innerHTML = newPrice;
      });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  renderProductInfo() {
    this.toggleAddButton(false, window.variantStrings.soldOut);
  }

  styleSelects() {
    new Choices(this.querySelector('.js-choice'));
    let name = this.querySelector('.choices__item.choices__item--selectable').innerHTML;
    if (name.charAt(0) != '$') {
      name = name.split('$')[0];
    }
    this.querySelector('.choices__item.choices__item--selectable').innerHTML = name;
  }
}
customElements.define("variant-card", VariantCard);
